// src/features/passwords/utils/sorters.js

/**
 * Sort an array of userCodeMainEntries by the `subscribed` field.
 *
 * @param {Array} list - Array of userCodeMainEntries
 * @param {'asc'|'desc'} direction - Sort order
 * @returns {Array}
 */
export function sortBySubscribed(list, direction = 'desc') {
    const sorted = [...list];
    sorted.sort((a, b) => {
      const valueA = a.subscribed ? 1 : 0;
      const valueB = b.subscribed ? 1 : 0;
      return direction === 'desc' ? valueB - valueA : valueA - valueB;
    });
    return sorted;
  }
  
  /**
   * Sort an array of userCodeMainEntries by the `onboarded` field.
   *
   * @param {Array} list - Array of userCodeMainEntries
   * @param {'asc'|'desc'} direction - Sort order
   * @returns {Array}
   */
  export function sortByOnboarded(list, direction = 'desc') {
    const sorted = [...list];
    sorted.sort((a, b) => {
      const valueA = a.onboarded ? 1 : 0;
      const valueB = b.onboarded ? 1 : 0;
      return direction === 'desc' ? valueB - valueA : valueA - valueB;
    });
    return sorted;
  }
  